import React from 'react'

import Base from '../_Base'

const BrazilA18 = (props) => (
  <Base width="24" height="24" viewBox="0 0 24 24" fill="none" {...props}>
    <g clipPath="url(#brazil_a18)">
      <rect width="24" height="24" rx="2" fill="#000" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17.148 13.729v.952c0 .505.04.84.119.992.08.153.22.233.425.233.198 0 .34-.085.42-.26.079-.177.119-.494.119-.965v-.952c0-.499-.04-.828-.114-.98-.08-.154-.215-.233-.42-.233-.203 0-.345.085-.424.25-.086.164-.125.487-.125.963Zm.04-4.422v.5c0 .515.033.85.107.997.074.153.204.227.391.227a.375.375 0 0 0 .375-.25c.067-.164.102-.493.102-.98v-.5c0-.498-.035-.827-.108-.986-.074-.159-.199-.238-.386-.238a.387.387 0 0 0-.38.25c-.068.17-.102.498-.102.98Zm-.63 2.42a1.778 1.778 0 0 1-.986-.674c-.238-.329-.357-.72-.357-1.179v-.572c0-.862.192-1.48.583-1.866.386-.385 1.02-.572 1.894-.572.867 0 1.497.193 1.877.572.385.38.572 1.004.572 1.866v.572c0 .46-.119.856-.351 1.185-.233.329-.562.55-.981.669.448.13.793.368 1.032.72.238.346.357.788.357 1.32v.925c0 .861-.199 1.48-.601 1.865-.397.385-1.038.578-1.922.578-.884 0-1.525-.193-1.916-.573-.392-.38-.584-1.003-.584-1.87v-.924c0-.539.119-.981.351-1.327.233-.346.579-.584 1.032-.714ZM11.966 7.028h1.684v9.938h-1.922V9.579c-.165.17-.346.323-.544.448a2.924 2.924 0 0 1-.641.312V8.553c.346-.193.635-.42.873-.674.244-.255.425-.539.55-.85ZM7.158 13.428h-.464l.464-4.115.465 4.115h-.465ZM9.131 7H5.186L3.802 17.023H6.57l.153-1.832h.873l.153 1.832h2.767L9.13 7Z"
        fill="#fff"
      />
    </g>
    <rect x=".5" y=".5" width="23" height="23" rx="1.5" stroke="#fff" />
    <defs>
      <clipPath id="brazil_a18">
        <rect width="24" height="24" rx="2" fill="#fff" />
      </clipPath>
    </defs>
  </Base>
)

export default BrazilA18
